import { useLayoutEffect } from 'react';
import type { ImageId } from '../../assets/marketing/manifest';
import type { VideoId } from '../content/videos';
import { useHeroContext } from '../layout/HeroContext';

interface HeroProps {
  image: ImageId;
  /** Empty by default: the hero is atmosphere, the text on the page carries the meaning. */
  alt?: string;
  /** Optional film played over `image`, which should be its still (VIDEOS[video].poster). */
  video?: VideoId;
}

/**
 * Declares the page's opening photograph, and optionally a film over it.
 * Renders nothing itself: the persistent HeroStage in the layout shows it,
 * crossfading from the previous page's photograph, and drives the nav's
 * landing travel from scroll. Declared in a layout effect so the stage has
 * the image before first paint.
 */
export default function Hero({ image, alt = '', video }: HeroProps) {
  const ctx = useHeroContext();
  const setHero = ctx?.setHero;
  useLayoutEffect(() => {
    if (!setHero) return undefined;
    setHero({ image, alt, video });
    return () => setHero({ image: null, alt: '' });
  }, [image, alt, video, setHero]);
  return null;
}
